import { connect } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    CAlert,
    CCol,
    CNav,
    CNavItem, CNavLink,
    CTabContent, CTabPane
} from "@coreui/react";

import "dayjs/locale/ko";
import "ag-grid-enterprise";
import "src/scss/grid-styles.scss";
import RejectReport from "./rejectReport";
import ProductRejectReport from "./productRejectReport";
import CornerRejectReport from "./cornerRejectReport";

const SaleRejectReport = (props) => {
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const [error, setError] = useState({
        visible: false,
        message: ""
    });
    const [activeKey, setActiveKey] = useState(1);

    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            // getStoreDevice();
        }
    }, [props.selected.storeCd]);

    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                    <h5>판매반품현황</h5>
                </div>
                <CCol>
                    <CNav variant="tabs" role="tablist">
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 1}
                                onClick={() => setActiveKey(1)}>반품현황</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 2}
                                onClick={() => setActiveKey(2)}>상품별 반품현황</CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 3}
                                onClick={() => setActiveKey(3)}>코너별 반품현황</CNavLink>
                        </CNavItem>
                    </CNav>
                    <CTabContent>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                            <div style={{height: 10}}/>
                            <RejectReport setLoading={props.setLoading} />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                            <div style={{height: 10}}/>
                            <ProductRejectReport setLoading={props.setLoading} />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 3}>
                            <div style={{height: 10}}/>
                            <CornerRejectReport setLoading={props.setLoading} />
                        </CTabPane>
                    </CTabContent>
                </CCol>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(SaleRejectReport);
